import { OverflowMenu } from './types';

export const createOverflowMenu = (): OverflowMenu => {
  const overflowMenuItem = document.createElement('li');
  overflowMenuItem.className = 'header-menu__item overflow-menu';
  overflowMenuItem.innerHTML = `<button type="button" class="overflow-menu__toggle"><span class="overflow-menu__label">Další</span><i class="overflow-menu__arrow"/></button>`;

  const overflowMenuList = document.createElement('ul');
  overflowMenuList.className = 'overflow-menu__list';
  overflowMenuItem.appendChild(overflowMenuList);

  const toggle = overflowMenuItem.querySelector('.overflow-menu__toggle') as HTMLElement;
  toggle.addEventListener('click', () => {
    overflowMenuItem.classList.toggle('active');
  });

  return { overflowMenuItem, overflowMenuList };
};
